import { render, staticRenderFns } from "./MobileFallbackPage.vue?vue&type=template&id=6186cc10&scoped=true&"
import script from "./MobileFallbackPage.vue?vue&type=script&lang=ts&"
export * from "./MobileFallbackPage.vue?vue&type=script&lang=ts&"
import style0 from "./MobileFallbackPage.vue?vue&type=style&index=0&id=6186cc10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6186cc10",
  null
  
)

export default component.exports